import { DispatchTypes } from '../types';

const clearError = () => ({ type: DispatchTypes.CLEAR_ERROR, payload: null });

export default clearError;
